import {
  GREY42,
  PLATINUM,
  ACTIVEGREEN,
  ALTO,
  RED,
  HOVERBLUE,
  WHITE,
  CHARCOAL,
  DOVEGREY,
  LIGHTGREY,
  BLACK,
  HRLINEGREY,
  BLUE,
  DARKGREEN,
  POWDER,
  DARKGREY
} from './color.js';

export default {
  header: {
    background: PLATINUM,
    navItem: GREY42,
    activeItem: ACTIVEGREEN,
    sideItem: GREY42
  },
  openRequests: {
    title: GREY42,
    rightButton: ACTIVEGREEN,
    buttonHover: HOVERBLUE,
    text: WHITE,
    sortSpan: CHARCOAL,
    table: LIGHTGREY,
    tableHover: POWDER,
    paginationColor: CHARCOAL,
    itemTitle: BLUE,
    itemDetail: DOVEGREY,
    processingState: DARKGREEN,
    outOfStockState: RED
  },
  forms: {
    leftButton: ALTO,
    rightButton: ACTIVEGREEN,
    leftButtonText: GREY42,
    buttonHover: HOVERBLUE,
    hoverText: WHITE,
    greyLine: HRLINEGREY,
    formName: CHARCOAL,
    black: BLACK,
    boxBorder: DARKGREY
  },
  steps: {
    active: CHARCOAL,
    item: PLATINUM,
    activeText: WHITE
  }
};



// WEBPACK FOOTER //
// ./src/theme/index.js